import { render, staticRenderFns } from "./DetailsPopup.vue?vue&type=template&id=0d39db23"
import script from "./DetailsPopup.vue?vue&type=script&lang=js"
export * from "./DetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./DetailsPopup.vue?vue&type=style&index=0&id=0d39db23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports